import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_LANGUAGE } from '../../../../configs/language'
import { register } from '../../../helpers/reducerRegistry'
import { CURRENCY } from '../../../utils/currency'
import { TABS_KEY } from '../preferences/constants'
import { LIST_FONT_SIZES } from '../settings/constants'
import { getUserSettingWithPreference } from './thunk'

const slice = createSlice({
  name: 'userManagement/settingPreferences',
  initialState: {
    settings: {
      currency: CURRENCY.USD,
      lang: DEFAULT_LANGUAGE,
      typeFontSize: LIST_FONT_SIZES[1].value,
      emailLang: DEFAULT_LANGUAGE,
    },
    form: {
      vsicChecked: [],
      icbChecked: [],
      province: [],
      foreign: [],
      vsic: [],
      icb: [],
    },
    vsicTree: {},
    icbTree: {},
    vsicOrIcbTab: TABS_KEY.VSIC,
    loading: true,
  },
  reducers: {
    setCurrency: (state, action) => {
      state.settings.currency = action.payload
    },
    setLanguage: (state, action) => {
      state.settings.lang = action.payload
    },
    setEmailLanguage: (state, action) => {
      state.settings.emailLang = action.payload
    },
    setTypeFontSize: (state, action) => {
      state.settings.typeFontSize = action.payload
    },
    setProvince: (state, action) => {
      state.form.province = action.payload
    },
    setForeign: (state, action) => {
      state.form.foreign = action.payload
    },
    setVsicTree: (state, action) => {
      state.vsicTree = action.payload
    },
    setVsic: (state, action) => {
      state.form.vsic = action.payload
    },
    setVsicChecked: (state, action) => {
      state.form.vsicChecked = action.payload
    },
    setIcbChecked: (state, action) => {
      state.form.icbChecked = action.payload
    },
    setIcbTree: (state, action) => {
      state.icbTree = action.payload
    },
    setIcb: (state, action) => {
      state.form.icb = action.payload
    },
    setVsicOrIcbTab: (state, action) => {
      state.vsicOrIcbTab = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getUserSettingWithPreference.fulfilled,
      (state, { payload = {} }) => {
        state.loading = false

        state.form.vsicChecked = payload.vsicIds || []
        state.form.icbChecked = payload.icbIds || []
        state.form.province = payload.localLocationIds || []
        state.form.foreign = payload.foreignLocationIds || []
        state.settings.currency = payload.currencyCode || CURRENCY.VND
        state.settings.emailLang = payload.languageCodeEmail || DEFAULT_LANGUAGE
      },
    )
  },
})

export const {
  setCurrency,
  setIcbChecked,
  setVsicChecked,
  setProvince,
  setForeign,
  setLanguage,
  setTypeFontSize,
  setVsic,
  setVsicTree,
  setIcbTree,
  setIcb,
  setVsicOrIcbTab,
  setEmailLanguage,
} = slice.actions

export const selectCurrency = (state) => state[slice.name].settings.currency

export const selectSettings = (state) => state[slice.name].settings

export const selectForm = (state) => state[slice.name].form

export const selectProvince = (state) => state[slice.name].form.province

export const selectForeign = (state) => state[slice.name].form.foreign

export const selectIcbChecked = (state) => state[slice.name].form.icbChecked

export const selectVsicChecked = (state) => state[slice.name].form.vsicChecked

export const selectVsicTree = (state) => state[slice.name].vsicTree

export const selectIcb = (state) => state[slice.name].form.icb

export const selectVsic = (state) => state[slice.name].form.vsic

export const selectIcbTree = (state) => state[slice.name].icbTree

export const selectVsicOrIcbTab = (state) => state[slice.name].vsicOrIcbTab

export const selectLoading = (state) => state[slice.name].loading

register(slice.name, slice.reducer)
